// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Form, FormItem, IFormInstance } from '@/components';
import { StyledField, StyledFieldInput, StyledFieldLabel, StyledFieldTextArea } from '../Styled';

// Helpers
import { SuggestedFaqFieldsNames, TSuggestedFaqFormValues } from '../../helpers';
import { useSuggestedFaqFormRules } from '../../hooks';

type TSuggestedFaqFormProps = {
  formInstance: IFormInstance;
  initialValues?: Partial<TSuggestedFaqFormValues>;
  disabled?: boolean;
};

const SuggestedFaqForm: FC<TSuggestedFaqFormProps> = ({ formInstance, initialValues, disabled }) => {
  const { t } = useTranslation();
  const rules = useSuggestedFaqFormRules();

  return (
    <Form form={formInstance} initialValues={initialValues} disabled={disabled}>
      <StyledField>
        <FormItem
          name={SuggestedFaqFieldsNames.QUESTION}
          rules={rules[SuggestedFaqFieldsNames.QUESTION]}
          label={<StyledFieldLabel>{t('label_question_one')}</StyledFieldLabel>}
        >
          <StyledFieldInput />
        </FormItem>
      </StyledField>
      <StyledField>
        <FormItem
          name={SuggestedFaqFieldsNames.ANSWER}
          rules={rules[SuggestedFaqFieldsNames.ANSWER]}
          label={<StyledFieldLabel>{t('label_answer_one')}</StyledFieldLabel>}
        >
          <StyledFieldTextArea disabled={disabled} rows={5} />
        </FormItem>
      </StyledField>
    </Form>
  );
};

export default SuggestedFaqForm;
